/*
 * SMParts — Suche
 *
 * Zwei Aufgaben:
 *   1. Leerzustand mit letzten und beliebten Suchen, solange nichts getippt ist.
 *   2. Letzte Suchen merken (nur lokal im Browser, kein Tracking, kein Server).
 *
 * Die Dawn-Suchlogik selbst wird nicht angefasst. Faellt dieses Script aus,
 * funktioniert die Suche unveraendert weiter — nur ohne Chips.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'smp:recent-searches';
  var MAX_RECENT = 6;

  /* ---------------------------------------------------------------- Storage */

  function readRecent() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (t) { return typeof t === 'string'; }) : [];
    } catch (e) {
      // Private Mode, volles Storage-Quota, deaktivierte Cookies
      return [];
    }
  }

  function writeRecent(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* nicht kritisch — Suche funktioniert auch ohne Historie */
    }
  }

  function rememberTerm(term) {
    var clean = (term || '').trim();
    if (clean.length < 2) return;

    var list = readRecent().filter(function (t) {
      return t.toLowerCase() !== clean.toLowerCase();
    });
    list.unshift(clean);
    writeRecent(list.slice(0, MAX_RECENT));
  }

  /* ------------------------------------------------------------ Leerzustand */

  function buildEmptyState(form) {
    var template = document.querySelector('[data-smp-search-empty-template]');
    if (!template || !('content' in template)) return null;

    var node = template.content.firstElementChild.cloneNode(true);
    form.appendChild(node);
    return node;
  }

  function renderRecent(root) {
    var group = root.querySelector('[data-smp-recent-group]');
    var list = root.querySelector('[data-smp-recent-list]');
    if (!group || !list) return;

    var terms = readRecent();
    list.textContent = '';

    if (!terms.length) {
      group.hidden = true;
      return;
    }

    terms.forEach(function (term) {
      var link = document.createElement('a');
      link.className = 'smp-chip';
      link.href =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'search?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last'
          : '/search?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
      link.textContent = term;
      list.appendChild(link);
    });

    group.hidden = false;
  }

  /* -------------------------------------------------------------------- Init */

  function init() {
    /*
     * Jedes Suchmodal einzeln verdrahten.
     *
     * Der Header rendert zwei — welches sichtbar ist, haengt vom
     * Breakpoint ab. Beide zu bestuecken ist einfacher und robuster,
     * als beim Resize umzuhaengen.
     */
    document.querySelectorAll('details-modal.header__search').forEach(setupModal);
  }

  function setupModal(modal) {
    var form = modal.querySelector('form[action*="search"]');
    var input = modal.querySelector('input[type="search"]');
    if (!form || !input) return;

    var emptyState = buildEmptyState(form);

    function syncEmptyState() {
      if (!emptyState) return;
      var isEmpty = input.value.trim().length === 0;
      emptyState.hidden = !isEmpty;
      if (isEmpty) renderRecent(emptyState);
    }

    input.addEventListener('input', syncEmptyState);
    input.addEventListener('focus', syncEmptyState);
    syncEmptyState();

    // Reset-Button raeumt das Feld — Dawn feuert dabei kein input-Event
    form.addEventListener('reset', function () {
      window.setTimeout(syncEmptyState, 0);
    });

    if (emptyState) {
      var clear = emptyState.querySelector('[data-smp-recent-clear]');
      if (clear) {
        clear.addEventListener('click', function () {
          writeRecent([]);
          renderRecent(emptyState);
        });
      }
    }

    // Suchbegriff merken
    form.addEventListener('submit', function () {
      rememberTerm(input.value);
    });

    // Auch Klicks auf Vorschlaege sind eine Suche
    modal.addEventListener('click', function (event) {
      var suggestion = event.target.closest('.predictive-search__item--term, [data-smp-chip]');
      if (suggestion) rememberTerm(suggestion.textContent);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
